import jsonp from 'jsonp'
import toQueryString from 'to-querystring'

export const subscribeToMailchimpList = (
  data: { EMAIL: string; FNAME?: string },
  mailchimpBaseURL: string,
  mailchimpListId: string,
  setMailchimpResponse?: (status: string, message: string | Error) => void
) => {
  const listURL = `${mailchimpBaseURL}${mailchimpListId}`
  const params = toQueryString(data)
  const url = listURL.replace('/post?', '/post-json?') + '&' + params
  jsonp(
    url,
    {
      param: 'c',
    },
    (err: Error, data: { msg: string; result: string }) => {
      if (err) {
        if (setMailchimpResponse) {
          setMailchimpResponse('error', err.message || String(err))
        } else {
          console.error(err)
        }
      } else if (data.result !== 'success') {
        if (setMailchimpResponse) {
          setMailchimpResponse('error', `${data.msg}`)
        } else {
          console.error(data.msg)
        }
      } else if (setMailchimpResponse) {
        setMailchimpResponse('success', `${data.msg}`)
      } else {
        console.log(data.msg)
      }
    }
  )
}
